import {db} from '@/firebase/init'
import _ from 'lodash';

export default {
    namespaced: true,
    state: {
        activeSalesTasks: [],
        backupTasks: [],
        resolvedSalesTasks: [],
        activeSupportTasks: [],
        resolvedSupportTasks: [],
        activeMigrationsTasks: [],
        reviewMigrationsTasks: [],
        abandonedMigrationsTasks: [],
        activeManualTaskListener: null,
        activeSalesListener: null,
        resolvedSalesListener: null,
        activeSupportListener: null,
        resolvedSupportListener: null,
        activeMigrationsListener: null,
        reviewMigrationsListener: null,
        abandonedMigrationsListener: null,
        taskLoader: false,
        backupLoader: false,
    },
    getters: {
        getTaskLoader(state) {
            return state.taskLoader;
        },
        getActiveSalesTasks(state) {
            return state.activeSalesTasks
        },
        getResolvedSalesTasks(state) {
            return state.resolvedSalesTasks
        },
        getActiveSalesTasksCount(state) {
            return state.activeSalesTasks.length
        },
        getBackupLoader(state) {
            return state.backupLoader
        },
        getActiveSupportTasks(state) {
            let urgent = [];
            let backupTasks = [];
            let migrationTasks = [];
            let uniqueVisitors = [];
            let missingCPanelDomainsTasks = [];
            state.activeSupportTasks.forEach((task) => {
                switch (task.text) {
                    case 'Backup Failure':
                        backupTasks.push(task);
                        break;
                    case 'New Migration':
                        migrationTasks.push(task);
                        break;
                    case 'Migration Initiated':
                        migrationTasks.push(task);
                        break;
                    case 'Domain Not Found':
                        uniqueVisitors.push(task);
                        break;
                    case 'C-Panel Missing Domain':
                        missingCPanelDomainsTasks.push(task);
                        break;
                    default:
                        urgent.push(task);
                }
            });
            return {
                urgent,
                backupTasks,
                migrationTasks,
                uniqueVisitors,
                missingCPanelDomainsTasks
            };
        },
        getResolvedSupportTasks(state) {
            return state.resolvedSupportTasks
        },
        getBackupSupportTasks(state) {
            return state.backupTasks
        },
        getActiveSupportTasksCount(state) {
            const urgentTasks = state.activeSupportTasks.filter(task => (task.text !== 'Domain Not Found' && task.text !== 'Backup Failure' && task.text !== 'New Migration' && task.text !== 'Migration Initiated' && task.text !== 'C-Panel Missing Domain' ) ).length;
            const newUrgent = state.activeSupportTasks.filter(task => (task.text !== 'Mediavine Integration' && task.text !== 'Domain Not Found' && task.text !== 'Backup Failure' && task.text !== 'New Migration' && task.text !== 'Migration Initiated' && task.text !== 'C-Panel Missing Domain' ) ).length;
            const mediavine = state.activeSupportTasks.filter(task => (task.text === 'Mediavine Integration')).length;
            const migrationTasks = state.activeSupportTasks.filter(task => ( task.text === 'Migration Initiated') ).length;
            const visitsTasks = state.activeSupportTasks.filter(task => ( task.text === 'Domain Not Found') ).length;
            const missingCpanelDomainTasks=  state.activeSupportTasks.filter(task => ( task.text === 'C-Panel Missing Domain') ).length;
            const nonUrgentTasks = state.activeSupportTasks.length - urgentTasks - migrationTasks - visitsTasks;
            return {
                urgent: urgentTasks,
                nonUrgent: nonUrgentTasks,
                migrations: migrationTasks,
                unique: visitsTasks,
                missingCpanelDomainTasks,
                mediavine,
                newUrgent
            }
        },
        getActiveMigrations (state) {
            return state.activeMigrationsTasks;
        },
        getReviewMigrations (state) {
            return state.reviewMigrationsTasks;
        },
        getAbandonedMigrations (state) {
            return state.abandonedMigrationsTasks;
        },
        getActiveMigrationsCount (state) {
            return state.activeMigrationsTasks.length;
        }

    },
    mutations: {
        mutateTaskLoader(state, value) {
            state.taskLoader = value
        },
        mutateActiveSalesTasks(state, payload) {
            if(payload.op === 'push') {
                state.activeSalesTasks = state.activeSalesTasks.filter(task => task.docId !== payload.data.docId);
                state.activeSalesTasks.push(payload.data)
            }else if(payload.op === 'filter') {
                state.activeSalesTasks = state.activeSalesTasks.filter(task => task.docId !== payload.data);
            }
            else if (payload.op === 'update') {
                const taskToUpdate = state.activeSalesTasks.find( (task) => task.docId === payload.data.docId );
                taskToUpdate.checkinBy = payload.data.checkinBy;
            }

            state.activeSalesTasks = _.orderBy(state.activeSalesTasks, ['createdAt'], ['asc']);
        },
        mutateActiveSupportTasks(state, payload) {
            if(payload.op === 'push') {
                state.activeSupportTasks.push(payload.data)
            }else if(payload.op === 'filter'){
                state.activeSupportTasks = state.activeSupportTasks.filter(task => task.docId !== payload.data);
            }else if (payload.op === 'update') {
                const taskToUpdate = state.activeSupportTasks.find( (task) => task.docId === payload.data.docId );
                taskToUpdate.sslStatus = payload.data.sslStatus;
                taskToUpdate.cfStatus = payload.data.cfStatus;
                taskToUpdate.checkinBy = payload.data.checkinBy;
            }
            state.activeSupportTasks = _.orderBy(state.activeSupportTasks, ['createdAt'], ['asc']);
        },
        mutateActiveMigrationsTasks (state, payload) {
            if(payload.op === 'push') {
                state.activeMigrationsTasks.push(payload.data)
            }else if(payload.op === 'filter'){
                state.activeMigrationsTasks = state.activeMigrationsTasks.filter(task => task.docId !== payload.data);
            }else if (payload.op === 'update') {
                const taskToUpdate = state.activeMigrationsTasks.find( (task) => task.docId === payload.data.docId );
                taskToUpdate.cloudflare.cf = payload.data.cloudflare.cf;
                taskToUpdate.cloudflare.ssl = payload.data.cloudflare.ssl;
                taskToUpdate.handledBy = payload.data.handledBy;
                taskToUpdate.ackMembership = payload.data.ackMembership;
                taskToUpdate.ackCollaborator = payload.data.ackCollaborator;
                taskToUpdate.ackAlternateEmail = payload.data.ackAlternateEmail;
                taskToUpdate.ackAdditionalDetail = payload.data.ackAdditionalDetail;
                taskToUpdate.ackNotes = payload.data.ackNotes;
                taskToUpdate.notifyUser = payload.data.notifyUser;
                taskToUpdate.ticketId = payload.data.ticketId;
                taskToUpdate.notes = payload.data.notes;
                taskToUpdate.tagCategories=payload.data.tagCategories || []
            }
            state.activeMigrationsTasks = _.orderBy(state.activeMigrationsTasks, ['created'], ['desc']);
        },
        mutateReviewMigrationsTasks (state, payload) {
            if(payload.op === 'push') {
                state.reviewMigrationsTasks.push(payload.data)
            }else if(payload.op === 'filter'){
                state.reviewMigrationsTasks = state.reviewMigrationsTasks.filter(task => task.docId !== payload.data);
            }else if (payload.op === 'update') {
                const taskToUpdate = state.reviewMigrationsTasks.find( (task) => task.docId === payload.data.docId );
                taskToUpdate.cloudflare.cf = payload.data.cloudflare.cf;
                taskToUpdate.cloudflare.ssl = payload.data.cloudflare.ssl;
                taskToUpdate.handledBy = payload.data.handledBy;
                taskToUpdate.ackMembership = payload.data.ackMembership;
                taskToUpdate.ackCollaborator = payload.data.ackCollaborator;
                taskToUpdate.ackAlternateEmail = payload.data.ackAlternateEmail;
                taskToUpdate.ackAdditionalDetail = payload.data.ackAdditionalDetail;
                taskToUpdate.ackNotes = payload.data.ackNotes;
                taskToUpdate.notifyUser = payload.data.notifyUser;
                taskToUpdate.ticketId = payload.data.ticketId;
                taskToUpdate.notes = payload.data.notes;
                taskToUpdate.tagCategories=payload.data.tagCategories || []
            }
            else if(payload.op === 'remove'){
                state.reviewMigrationsTasks = []
            }
            state.reviewMigrationsTasks = _.orderBy(state.reviewMigrationsTasks, ['created'], ['desc']);
        },
        mutateAbandonedMigrationsTasks (state, payload) {
            if(payload.op === 'push') {
                state.abandonedMigrationsTasks.push(payload.data)
            }else if(payload.op === 'filter'){
                state.abandonedMigrationsTasks = state.abandonedMigrationsTasks.filter(task => task.docId !== payload.data);
            }else if (payload.op === 'update') {
                const taskToUpdate = state.abandonedMigrationsTasks.find( (task) => task.docId === payload.data.docId );
                taskToUpdate.cloudflare.cf = payload.data.cloudflare.cf;
                taskToUpdate.cloudflare.ssl = payload.data.cloudflare.ssl;
                taskToUpdate.handledBy = payload.data.handledBy;
                taskToUpdate.ackMembership = payload.data.ackMembership;
                taskToUpdate.ackCollaborator = payload.data.ackCollaborator;
                taskToUpdate.ackAlternateEmail = payload.data.ackAlternateEmail;
                taskToUpdate.ackAdditionalDetail = payload.data.ackAdditionalDetail;
                taskToUpdate.ackNotes = payload.data.ackNotes;
                taskToUpdate.ticketId = payload.data.ticketId;
                taskToUpdate.notes = payload.data.notes;
                taskToUpdate.tagCategories=payload.data.tagCategories || []

            }
            else if(payload.op === 'remove'){
                state.abandonedMigrationsTasks = []
            }
            state.abandonedMigrationsTasks = _.orderBy(state.abandonedMigrationsTasks, ['created'], ['desc']);
        },
        mutateResolvedSalesTasks(state, payload) {
            state.resolvedSalesTasks.push(payload)
            state.resolvedSalesTasks = _.orderBy(state.resolvedSalesTasks, ['resolvedAt'], ['desc']);
        },
        mutateBackupSupportTasks(state, payload) {
            state.backupTasks = payload;
        },
        mutateResolvedSupportTasks(state, payload) {
            state.resolvedSupportTasks.push(payload)
            state.resolvedSupportTasks = _.orderBy(state.resolvedSupportTasks, ['resolvedAt'], ['desc']);
        },
        mutateActiveSalesListener(state, payload){
            state.activeSalesListener = payload;
        },
        mutateActiveManualTaskListener(state, payload){
            state.activeManualTaskListener= payload
        },
        mutateBackupLoader(state, payload){
            state.backupLoader= payload
        },
        mutateResolvedSalesListener(state, payload){
            state.resolvedSalesListener = payload;
        },
        mutateActiveSupportListener(state, payload){
            state.activeSupportListener = payload;
        },
        mutateResolvedSupportListener(state, payload){
            state.resolvedSupportListener = payload;
        },
        mutateActiveMigrationsListener(state, payload){
            state.activeMigrationsListener = payload;
        },
        mutateReviewMigrationsListener(state, payload){
            state.reviewMigrationsListener = payload;
        },
        mutateAbandonedMigrationsListener(state, payload){
            state.abandonedMigrationsListener = payload;
        }

    },
    actions: {
        getActiveManualTasks(context){
            let activeQuery = null;
            let activeListener = null;
            activeQuery= db.collection('manualTasks')
                .orderBy("createdAt", "desc");
            activeListener=  activeQuery.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        if(changeDoc.doc.data().type==='support' && changeDoc.doc.data().resolved===false ){
                            // console.log('New Pending Task Added...');
                            context.commit('mutateActiveSupportTasks', {
                                op: 'push',
                                data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                            })
                        }else if(changeDoc.doc.data().type==='sales' && changeDoc.doc.data().resolved===false){
                            // console.log('New Pending Task Added...');
                            context.commit('mutateActiveSalesTasks', {
                                op: 'push',
                                data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                            })
                        }
                    } else if(changeDoc.type === 'removed' || changeDoc.type=='modified') {
                        if(changeDoc.doc.data().type==='support' && changeDoc.doc.data().resolved===true){
                            context.commit('mutateActiveSupportTasks', {
                                op: 'filter',
                                data: changeDoc.doc.id
                            });
                        }
                        else if(changeDoc.doc.data().type==='sales' && changeDoc.doc.data().resolved===true){
                            context.commit('mutateActiveSalesTasks', {
                                op: 'filter',
                                data: changeDoc.doc.id
                            });
                        }
                    }
                });
            });
            context.commit('mutateActiveManualTaskListener', activeListener);
        },
        changeTaskLoader(context, payload) {
            context.commit('mutateTaskLoader', payload)
        },
        fetchActiveSalesTasks(context) {
            let activeQuery = null;
            let activeListener = null;
            activeQuery = db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'sales')
                .orderBy("createdAt", "desc");
            activeListener = activeQuery.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Pending Task Added...');
                        context.commit('mutateActiveSalesTasks', {
                            op: 'push',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    }
                    else if (changeDoc.type === 'modified') {
                        context.commit('mutateActiveSalesTasks', {
                            op: 'update',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    }
                    else if(changeDoc.type === 'removed') {
                        console.log('Pending Task Removed...');
                        context.commit('mutateActiveSalesTasks', {
                            op: 'filter',
                            data: changeDoc.doc.id
                        });
                        context.commit('mutateTaskLoader', false);
                    }
                });
            });
            context.commit('mutateActiveSalesListener', activeListener);
        },
        fetchActiveSupportTasks(context) {
            let activeQuery = null;
            let activeListener = null;
            activeQuery = db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', 'not-in', ['Backup Failure', 'C-Panel Missing Domain', 'Migration Initiated', 'Domain Not Found'])
                .orderBy("text", "desc")
                .orderBy("createdAt", "desc");
            activeListener = activeQuery.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Pending Support Task Added...');
                        context.commit('mutateActiveSupportTasks', {
                            op: 'push',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    } else if (changeDoc.type === 'modified') {
                        context.commit('mutateActiveSupportTasks', {
                            op: 'update',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    } else if(changeDoc.type === 'removed') {
                        console.log('Pending Support Task Removed...');
                        context.commit('mutateActiveSupportTasks', {
                            op: 'filter',
                            data: changeDoc.doc.id
                        });
                        context.commit('mutateTaskLoader', false);
                    }
                });
            });
            context.commit('mutateActiveSupportListener', activeListener);
        },
        async fetchBackupSupportTasks(context) {
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', '==', 'Backup Failure')
                .orderBy("createdAt", "desc").get();
            const allBackups = [];
            if(ref.size) {
                ref.forEach(el => {
                    allBackups.push({docId: el.id, ...el.data()})
                })
            }
            context.commit('mutateBackupSupportTasks', allBackups);
            context.commit('mutateBackupLoader', false);
        },
        backupLoader(context, value) {
            context.commit('mutateBackupLoader', value);
        },
        fetchActiveMigrationsTasks(context) {
            console.log('Fetching saved migrations...');
            let activeQuery = null;
            let activeListener = null;
            activeQuery = db.collection('savedMigrations').where('status', '==', 'pending');
            activeListener = activeQuery.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Pending Migrations Task Added...');
                        context.commit('mutateActiveMigrationsTasks', {
                            op: 'push',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    } else if (changeDoc.type === 'modified') {
                        context.commit('mutateActiveMigrationsTasks', {
                            op: 'update',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    } else if(changeDoc.type === 'removed') {
                        console.log('Pending Migrations Task Removed...');
                        context.commit('mutateActiveMigrationsTasks', {
                            op: 'filter',
                            data: changeDoc.doc.id
                        });
                    }
                });
            });
            context.commit('mutateActiveMigrationsListener', activeListener);
        },
        async fetchReviewMigrationsTasks(context) {
            console.log('Fetching review migrations...');
            let reviewQuery = null;
            let reviewListener = null;
            reviewQuery = await db.collection('savedMigrations').where('status', '==', 'review')
            reviewListener = reviewQuery.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added'){
                        console.log('New Pending Migrations Task Added...');
                        context.commit('mutateReviewMigrationsTasks', {
                            op: 'push',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    } else if (changeDoc.type === 'modified') {
                        context.commit('mutateReviewMigrationsTasks', {
                            op: 'update',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    } else if(changeDoc.type === 'removed') {
                        console.log('Pending Migrations Task Removed...');
                        context.commit('mutateReviewMigrationsTasks', {
                            op: 'filter',
                            data: {docId: changeDoc.doc.id, ...changeDoc.doc.data()}
                        })
                    }
                });
            });
            context.commit('mutateReviewMigrationsListener', reviewListener);
        },
        async fetchAbandonedMigrationsTasks(context) {
            console.log('Fetching review migrations...');
            let reviewQuery = null;
            let reviewListener = null;
            context.commit('mutateAbandonedMigrationsTasks', {
                op: 'remove',
            })
            reviewQuery = await db.collection('savedMigrations').where('status', '==', 'abandoned').get();
            if(reviewQuery.size) {
                reviewQuery.forEach(el => {
                    context.commit('mutateAbandonedMigrationsTasks', {
                        op: 'push',
                        data: {docId: el.id, ...el.data()}
                    })
                })
            }
            context.commit('mutateAbandonedMigrationsListener', reviewListener);
        },
        fetchResolvedSalesTasks(context) {
            let resolvedQuery = null;
            let resolvedListener = null;
            resolvedQuery = db.collection('bigScootsTasks')
                .where('status', '==', 'resolved')
                .where('type', '==', 'sales')
                .orderBy("createdAt", "desc")
                .limit(500);
            resolvedListener = resolvedQuery.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added') {
                        console.log('New Resolved Task Added...');
                        context.commit('mutateResolvedSalesTasks', {docId: changeDoc.doc.id, ...changeDoc.doc.data()})
                    }
                })
            });
            context.commit('mutateResolvedSalesListener', resolvedListener);
        },
        fetchResolvedSupportTasks(context) {
            let resolvedQuery = null;
            let resolvedListener = null;
            resolvedQuery = db.collection('bigScootsTasks')
                .where('status', '==', 'resolved')
                .where('type', '==', 'support')
                .orderBy("resolvedAt", "desc")
                .limit(500);
            resolvedListener = resolvedQuery.onSnapshot(querySnapshot => {
                querySnapshot.docChanges().forEach(changeDoc => {
                    if (changeDoc.type === 'added') {
                        console.log('New Resolved Support Task Added...');
                        context.commit('mutateResolvedSupportTasks', {docId: changeDoc.doc.id, ...changeDoc.doc.data()})
                    }
                })
            });
            context.commit('mutateResolvedSupportListener', resolvedListener);
        },
        resetActiveSalesListener( { state } ) {
            state.activeSalesTasks = [];
            if (state.activeSalesListener) {
                state.activeSalesListener()
            }
        },
        resetResolvedSalesListener( { state } ) {
            state.resolvedSalesTasks = [];
            if (state.resolvedSalesListener) {
                state.resolvedSalesListener();
            }

        },
        resetActiveSupportListener( { state } ) {
            state.activeSupportTasks = [];
            console.log('Resetting Migration tasks / Listener...');
            state.activeMigrationsTasks = [];
            state.reviewMigrationsTasks = [];
            state.abandonedMigrationsTasks = [];
            if (state.activeSupportListener) {
                state.activeSupportListener();
            }
            if(state.activeMigrationsListener) {
                state.activeMigrationsListener();
            }
            if(state.reviewMigrationsListener) {
                state.reviewMigrationsListener();
            }
            if(state.abandonedMigrationsListener) {
                state.abandonedMigrationsListener();
            }
        },
        resetReviewMigrationListener( { state } ) {
            state.reviewMigrationsTasks = [];
            if(state.reviewMigrationsListener) {
                state.reviewMigrationsListener();
            }
        },
        resetResolvedSupportListener( { state } ) {
            state.resolvedSupportTasks = [];
            if (state.resolvedSupportListener) {
                state.resolvedSupportListener();
            }
        }
    }
}
